import React, { useMemo } from 'react'
import Breadcrumb from '../../components/common/Breadcrumb'
import ReactApexChart from 'react-apexcharts'
import ReactDataTable from 'react-data-table-component';
import { Link } from 'react-router-dom';
import {
  IconBell,
  IconBookmark,
  IconCalendar,
  IconClock,
  IconEye,
  IconFile,
  IconFileCode,
  IconMail,
  IconMessageCircle2,
  IconPhone,
  IconTag,
  IconCalendarBolt,
} from '@tabler/icons-react';
import {
  avatar1,
  avatar10,
  avatar11,
  avatar12,
  avatar13,
  avatar2,
  avatar3,
  avatar4,
  avatar6,
  avatar7,
  avatar8,
  avatar9,
  userProfile,
} from '../../assets/images';

export default function Dashboard() {

  const chartData = {
    series: [{
      name: 'Task 1',
      data: [38, 35, 62, 41, 45, 57, 40, 85, 22, 95],
    },
    {
      name: 'Task 2',
      data: [20, 42, 15, 50, 24, 48, 28, 55, 45, 60],
    },
    {
      name: 'Task 3',
      data: [35, 30, 36, 28, 60, 35, 59, 19, 58, 30],
    }],
    options: {
      colors: ['var(--chart-color1)', 'var(--chart-color2)', 'var(--chart-color3)'],
      fill: {
        gradient: {
          inverseColors: true,
          opacityTo: 0.2,
          stops: [0, 0],
        }
      },
      stroke: {
        width: 1,
        curve: 'smooth',
      },
      dataLabels: {
        enabled: false
      },
      markers: {
        size: 1,
        strokeColors: ['var(--chart-color1)', 'var(--chart-color2)', 'var(--chart-color3)'],
        hover: {
          size: 1,
        }
      },
      chart: {
        toolbar: {
          show: false,
        },
      },
      grid: {
        borderColor: 'var(--border)',
      },
      xaxis: {
        categories: ["2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021"],
        labels: {
          style: {
            fontFamily: 'var(--font-family)',
          },
        },
        tooltip: {
          enabled: false,
        },
      },
      yaxis: {
        min: 0,
        max: 100,
        tickAmount: 5,
        labels: {
          style: {
            fontFamily: 'var(--font-family)',
          },
        }
      },
      legend: {
        position: 'top',
        horizontalAlign: 'center',
      },
      responsive: [{
        breakpoint: 767,
        options: {
          chart: {
            height: 'auto'
          }
        },
      }]
    },
  };

  const chartData1 = {
    options: {
      stroke: {
        width: 1.5,
        curve: 'straight',
      },
      fill: {
        type: "solid",
      },
      colors: ['var(--chart-color1)'],
      dataLabels: {
        enabled: false
      },
      grid: {
        show: false,
      },
      chart: {
        toolbar: {
          show: false,
        },
        sparkline: {
          enabled: true
        },
      },
      xaxis: {
        categories: [1, 2, 3, 4, 5, 6, 7, 8],
        labels: {
          show: false,
        },
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        tooltip: {
          enabled: false,
        },
        crosshairs: {
          position: 'front',
          stroke: {
            color: 'var(--danger)',
            dashArray: 0,
          },
        }
      },
      yaxis: {
        show: false,
        min: 0,
        max: 8,
        tickAmount: 1,
      },
      tooltip: {
        x: {
          show: false,
        },
        style: {
          fontFamily: 'var(--font-family)',
        },
      },
      markers: {
        size: 0,
        hover: {
          size: 0,
        }
      },
    },
    series: [
      {
        name: "",
        data: [3, 5, 1, 6, 5, 4, 8, 3]
      }
    ]
  };

  const chartData2 = {
    options: {
      stroke: {
        width: 1.5,
        curve: 'straight',
      },
      fill: {
        type: "solid",
      },
      colors: ['var(--chart-color2)'],
      dataLabels: {
        enabled: false
      },
      grid: {
        show: false,
      },
      chart: {
        toolbar: {
          show: false,
        },
        sparkline: {
          enabled: true
        },
      },
      xaxis: {
        categories: [1, 2, 3, 4, 5, 6, 7, 8],
        labels: {
          show: false,
        },
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        tooltip: {
          enabled: false,
        },
        crosshairs: {
          position: 'front',
          stroke: {
            color: 'var(--danger)',
            dashArray: 0,
          },
        }
      },
      yaxis: {
        show: false,
        min: 0,
        max: 6,
        tickAmount: 1,
      },
      tooltip: {
        x: {
          show: false,
        },
        style: {
          fontFamily: 'var(--font-family)',
        },
      },
      markers: {
        size: 0,
        hover: {
          size: 0,
        }
      },
    },
    series: [
      {
        name: "",
        data: [4, 6, 3, 2, 5, 6, 5, 4]
      }
    ]
  };

  const chartData3 = {
    options: {
      stroke: {
        width: 1.5,
        curve: 'straight',
      },
      fill: {
        type: "solid",
      },
      colors: ['var(--chart-color3)'],
      dataLabels: {
        enabled: false
      },
      grid: {
        show: false,
      },
      chart: {
        toolbar: {
          show: false,
        },
        sparkline: {
          enabled: true
        },
      },
      xaxis: {
        categories: [1, 2, 3, 4, 5, 6, 7, 8],
        labels: {
          show: false,
        },
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        tooltip: {
          enabled: false,
        },
        crosshairs: {
          position: 'front',
          stroke: {
            color: 'var(--danger)',
            dashArray: 0,
          },
        }
      },
      yaxis: {
        show: false,
        min: 0,
        max: 8,
        tickAmount: 1,
      },
      tooltip: {
        x: {
          show: false,
        },
        style: {
          fontFamily: 'var(--font-family)',
        },
      },
      markers: {
        size: 0,
        hover: {
          size: 0,
        }
      },
    },
    series: [
      {
        name: "",
        data: [7, 3, 2, 1, 5, 4, 6, 8]
      }
    ]
  };

  const chartData4 = {
    options: {
      stroke: {
        width: 1.5,
        curve: 'straight',
      },
      fill: {
        type: "solid",
      },
      colors: ['var(--chart-color4)'],
      dataLabels: {
        enabled: false
      },
      grid: {
        show: false,
      },
      chart: {
        toolbar: {
          show: false,
        },
        sparkline: {
          enabled: true
        },
      },
      xaxis: {
        categories: [1, 2, 3, 4, 5, 6, 7, 8],
        labels: {
          show: false,
        },
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        tooltip: {
          enabled: false,
        },
        crosshairs: {
          position: 'front',
          stroke: {
            color: 'var(--danger)',
            dashArray: 0,
          },
        }
      },
      yaxis: {
        show: false,
        min: 0,
        max: 6,
        tickAmount: 1,
      },
      tooltip: {
        x: {
          show: false,
        },
        style: {
          fontFamily: 'var(--font-family)',
        },
      },
      markers: {
        size: 0,
        hover: {
          size: 0,
        }
      },
    },
    series: [
      {
        name: "",
        data: [3, 1, 2, 5, 4, 6, 2, 3]
      }
    ]
  };

  const chartData5 = {
    series: [6, 4, 2, 8],
    options: {
      labels: ['Quarter 1', 'Quarter 2', 'Quarter 3', 'Quarter 4'],
      colors: ['var(--chart-color1)', 'var(--chart-color2)', 'var(--chart-color3)', 'var(--chart-color4)'],
      legend: {
        show: false,
      },
      stroke: {
        colors: 'var(--bg-dark)'
      },
      dataLabels: {
        enabled: false,
      },
    },
  };

  const chartData6 = {
    options: {
      stroke: {
        width: 0,
        curve: 'smooth',
      },
      fill: {
        type: "solid",
      },
      colors: ['var(--chart-color1)'],
      dataLabels: {
        enabled: false
      },
      chart: {
        toolbar: {
          show: false,
        },
        sparkline: {
          enabled: true
        },
      },
      grid: {
        show: false,
      },
      xaxis: {
        categories: [1, 2, 3, 4, 5, 6, 7, 8],
        labels: {
          show: false,
        },
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        tooltip: {
          enabled: false,
        },
        crosshairs: {
          position: 'front',
          stroke: {
            color: 'var(--danger)',
            dashArray: 0,
          },
        }
      },
      yaxis: {
        show: false,
        min: 0,
        max: 8,
        tickAmount: 1,
      },
      tooltip: {
        x: {
          show: false,
        },
        style: {
          fontFamily: 'var(--font-family)',
        },
      },
      markers: {
        size: 0,
        hover: {
          size: 0,
        }
      },
    },
    series: [
      {
        name: "",
        data: [2, 4, 3, 1, 5, 7, 3, 2]
      }
    ]
  };

  const chatItem = [
    {
      image: avatar1,
      name: "Chris Fox",
      designation: "Designer, Blogger",
    },
    {
      image: avatar2,
      name: "Joge Lucky",
      designation: "Java Developer",
    },
    {
      image: avatar3,
      name: "Isabella",
      designation: "CEO, Lucid",
    },
    {
      image: avatar7,
      name: "Folisise Chosielie",
      designation: "Art director, Movie Cut",
    },
    {
      image: avatar8,
      name: "Alexander",
      designation: "Writter, Mag Editor",
    },
  ]

  const columnsFilter = [
    {
      name: 'Application',
      selector: row => row.application,
      sortable: true,
      style: {
        fontWeight: "700",
      },
    },
    {
      name: 'Team',
      selector: row => row.team,
    },
    {
      name: 'Change',
      selector: row => row.change,
    },
    {
      name: 'Sales',
      selector: row => row.sales,
      sortable: true,
    },
    {
      name: 'Price',
      selector: row => row.price,
      sortable: true,
    },
    {
      name: 'Total',
      selector: row => row.total,
      sortable: true,
      style: {
        fontWeight: "700",
      },
    },
  ];

  const dataFilter = [
    {
      application: 'Alpino 4.1',
      team:
        <ul className="flex items-center py-5">
          <li className='hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar1} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white' /></li>
          <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar2} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white' /></li>
          <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar3} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white' /></li>
        </ul>,
      change: <ReactApexChart options={chartData1.options} series={chartData1.series} type="line" height={30} width={120} />,
      sales: '11,200',
      price: '$83',
      total: '$22,520',
    },
    {
      application: 'Compass 2.0',
      team:
        <ul className="flex items-center py-5">
          <li className='hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar2} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white' /></li>
          <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar3} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white' /></li>
        </ul>,
      change: <ReactApexChart options={chartData2.options} series={chartData2.series} type="line" height={30} width={120} />,
      sales: '11,200',
      price: '$66',
      total: '$13,205',
    },
    {
      application: 'Nexa 1.1',
      team:
        <ul className="flex items-center py-5">
          <li className='hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar4} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white' /></li>
          <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar6} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white' /></li>
        </ul>,
      change: <ReactApexChart options={chartData4.options} series={chartData4.series} type="line" height={30} width={120} />,
      sales: '12,080',
      price: '$93',
      total: '$17,700',
    },
    {
      application: 'Oreo 2.2',
      team:
        <ul className="flex items-center py-5">
          <li className='hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar7} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white' /></li>
          <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar8} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white' /></li>
          <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar9} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white' /></li>
          <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar10} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white' /></li>
        </ul>,
      change: <ReactApexChart options={chartData3.options} series={chartData3.series} type="line" height={30} width={120} />,
      sales: '18,200',
      price: '$178',
      total: '$17700',
    },
  ]

  const [filterText, setFilterText] = React.useState('');
  const [resetPaginationToggle, setResetPaginationToggle] = React.useState(false);
  const filteredItems = dataFilter.filter(
    item =>
      item.application.toLowerCase().includes(filterText.toLowerCase()) ||
      item.sales.toLowerCase().includes(filterText.toLowerCase()) ||
      item.price.toLowerCase().includes(filterText.toLowerCase()) ||
      item.total.toLowerCase().includes(filterText.toLowerCase())
  );

  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText('');
      }
    };

    return (
      <div className='flex gap-5 mb-10 w-full justify-end'>
        <div className='relative w-full max-w-[221px]'>
          <input
            type='text'
            id='search'
            value={filterText}
            onChange={e => setFilterText(e.target.value)}
            placeholder='Search here...'
            className='bg-bg-light border border-border w-full py-[6px] px-3 min-h-[40px] rounded-[4px] placeholder:text-text-secondary focus:outline-none'
          />
        </div>
        <button onClick={handleClear} className="btn btn-danger">
          Clear
        </button>
      </div>
    );
  }, [filterText, resetPaginationToggle]);

  return (
    <>
      <Breadcrumb title="Project Dashboard" path="Project Dashboard" />
      <div className='grid xl:grid-cols-4 md:grid-cols-2 grid-cols-1 gap-30 mb-30'>
        <div className='bg-primary rounded-lg shadow-light md:p-20 p-15 text-white'>
          <div className='p-15 text-center'>
            <div className='text-[28px]/[33.6px] font-medium mb-2'>
              19
            </div>
            <div>
              Today Works
            </div>
          </div>
        </div>
        <div className='bg-yellow rounded-lg shadow-light md:p-20 p-15 text-white'>
          <div className='p-15 text-center'>
            <div className='text-[28px]/[33.6px] font-medium mb-2'>
              15
            </div>
            <div>
              Today Tasks
            </div>
          </div>
        </div>
        <div className='bg-black-100 rounded-lg shadow-light md:p-20 p-15 text-white'>
          <div className='p-15 text-center'>
            <div className='text-[28px]/[33.6px] font-medium mb-2'>
              125
            </div>
            <div>
              Statistics
            </div>
          </div>
        </div>
        <div className='bg-sky rounded-lg shadow-light md:p-20 p-15 text-white'>
          <div className='p-15 text-center'>
            <div className='text-[28px]/[33.6px] font-medium mb-2'>
              318
            </div>
            <div>
              Analytics
            </div>
          </div>
        </div>
      </div>
      <div className='bg-bg-dark shadow-light rounded-lg mb-30'>
        <div className='md:p-20 p-15'>
          <p className='text-[16px]/[19.2px] font-medium'>
            Wrok Report
          </p>
        </div>
        <ReactApexChart options={chartData.options} series={chartData.series} type="area" height={350} />
      </div>
      <div className='grid lg:grid-cols-3 grid-cols-1 gap-30 mb-30'>
        <div className='bg-bg-dark rounded-lg shadow-light'>
          <Link to="/inbox" className='flex items-center gap-15 justify-between md:py-3 md:px-15 p-10 border-b border-border last:border-none group'>
            <div className='flex items-center gap-10'>
              <IconMail className='text-text-secondary stroke-[1.5] w-[20px] h-[20px]' />
              <p className='text-blue transition-all duration-300 group-hover:text-blue-100'>
                Inbox
              </p>
            </div>
            <span className='inline-block rounded text-white bg-success py-[3px] px-2 text-[10.5px]/[12px]'>
              654
            </span>
          </Link>
          <Link to="#" className='flex items-center gap-15 justify-between md:py-3 md:px-15 p-10 border-b border-border last:border-none group'>
            <div className='flex items-center gap-10'>
              <IconEye className='text-text-secondary stroke-[1.5] w-[20px] h-[20px]' />
              <p className='text-blue transition-all duration-300 group-hover:text-blue-100'>
                Profile visits
              </p>
            </div>
            <span className='inline-block rounded text-white bg-yellow py-[3px] px-2 text-[10.5px]/[12px]'>
              364
            </span>
          </Link>
          <Link to="#" className='flex items-center gap-15 justify-between md:py-3 md:px-15 p-10 border-b border-border last:border-none group'>
            <div className='flex items-center gap-10'>
              <IconBookmark className='text-text-secondary stroke-[1.5] w-[20px] h-[20px]' />
              <p className='text-blue transition-all duration-300 group-hover:text-blue-100'>
                Bookmarks
              </p>
            </div>
            <span className='inline-block rounded text-white bg-danger py-[3px] px-2 text-[10.5px]/[12px]'>
              19
            </span>
          </Link>
          <Link to="#" className='flex items-center gap-15 justify-between md:py-3 md:px-15 p-10 border-b border-border last:border-none group'>
            <div className='flex items-center gap-10'>
              <IconPhone className='text-text-secondary stroke-[1.5] w-[20px] h-[20px]' />
              <p className='text-blue transition-all duration-300 group-hover:text-blue-100'>
                Call
              </p>
            </div>
            <span className='inline-block rounded text-white bg-blue py-[3px] px-2 text-[10.5px]/[12px]'>
              12
            </span>
          </Link>
          <Link to="#" className='flex items-center gap-15 justify-between md:py-3 md:px-15 p-10 border-b border-border last:border-none group'>
            <div className='flex items-center gap-10'>
              <IconMessageCircle2 className='text-text-secondary stroke-[1.5] w-[20px] h-[20px]' />
              <p className='text-blue transition-all duration-300 group-hover:text-blue-100'>
                Message
              </p>
            </div>
            <span className='inline-block rounded text-white bg-warning py-[3px] px-2 text-[10.5px]/[12px]'>
              54
            </span>
          </Link>
          <Link to="#" className='flex items-center gap-15 justify-between md:py-3 md:px-15 p-10 border-b border-border last:border-none group'>
            <div className='flex items-center gap-10'>
              <IconBell className='text-text-secondary stroke-[1.5] w-[20px] h-[20px]' />
              <p className='text-blue transition-all duration-300 group-hover:text-blue-100'>
                Notifications
              </p>
            </div>
            <span className='inline-block rounded text-white bg-info py-[3px] px-2 text-[10.5px]/[12px]'>
              544
            </span>
          </Link>
          <Link to="#" className='flex items-center gap-15 justify-between md:py-3 md:px-15 p-10 border-b border-border last:border-none group'>
            <div className='flex items-center gap-10'>
              <IconTag className='text-text-secondary stroke-[1.5] w-[20px] h-[20px]' />
              <p className='text-blue transition-all duration-300 group-hover:text-blue-100'>
                New Project
              </p>
            </div>
            <span className='inline-block rounded text-white bg-blue py-[3px] px-2 text-[10.5px]/[12px]'>
              16
            </span>
          </Link>
          <Link to="#" className='flex items-center gap-15 justify-between md:py-3 md:px-15 p-10 border-b border-border last:border-none group'>
            <div className='flex items-center gap-10'>
              <IconClock className='text-text-secondary stroke-[1.5] w-[20px] h-[20px]' />
              <p className='text-blue transition-all duration-300 group-hover:text-blue-100'>
                Watch
              </p>
            </div>
            <span className='inline-block rounded text-white bg-dark py-[3px] px-2 text-[10.5px]/[12px]'>
              29
            </span>
          </Link>
        </div>
        <div className='bg-bg-dark rounded-lg shadow-light'>
          <div className='flex flex-col'>
            {chatItem.map((item, key) => (
              <div key={key} className='flex items-center gap-10 group cursor-pointer p-15 border-b border-border last:border-none'>
                <div className='relative'>
                  <img src={item.image} alt='profile' width="40" height="40" className='w-[40px] h-[40px] border-2 border-transparent object-cover rounded-full transition-all duration-300 ease-in-out group-hover:border-primary' />
                </div>
                <div className='text-left'>
                  <p className='text-[15px]/[22.5px]'>
                    {item.name}
                  </p>
                  <p className='text-[13px]/[19.5px] text-text-secondary'>
                    {item.designation}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
          <div className='text-[16px]/[19.2px] font-medium mb-5'>
            To Do List
          </div>
          <div className='mb-30 text-text-secondary'>
            This Month task list
          </div>
          <ul>
            <li className='pb-15 mb-15 last:pb-0 last:mb-0 border-b border-border last:border-none'>
              <label className='cus-checkbox to-do text-text-primary flex items-center gap-10'>
                <input type='checkbox' defaultChecked />
                <span className='checkmark'></span>
                <span className='to-do-text flex items-center gap-5'>
                  <IconCalendar className='stroke-[1.5] w-20 h-20' />
                  Design Team Report
                </span>
              </label>
            </li>
            <li className='pb-15 mb-15 last:pb-0 last:mb-0 border-b border-border last:border-none'>
              <label className='cus-checkbox to-do text-text-primary flex items-center gap-10'>
                <input type='checkbox' />
                <span className='checkmark'></span>
                <span className='to-do-text flex items-center gap-5'>
                  <IconBell className='stroke-[1.5] w-20 h-20' />
                  New Logo Design
                </span>
              </label>
            </li>
            <li className='pb-15 mb-15 last:pb-0 last:mb-0 border-b border-border last:border-none'>
              <label className='cus-checkbox to-do text-text-primary flex items-center gap-10'>
                <input type='checkbox' />
                <span className='checkmark'></span>
                <span className='to-do-text flex items-center gap-5'>
                  <IconFile className='stroke-[1.5] w-20 h-20' />
                  Design PSD files
                </span>
              </label>
            </li>
            <li className='pb-15 mb-15 last:pb-0 last:mb-0 border-b border-border last:border-none'>
              <label className='cus-checkbox to-do text-text-primary flex items-center gap-10'>
                <input type='checkbox' />
                <span className='checkmark'></span>
                <span className='to-do-text flex items-center gap-5'>
                  <IconFileCode className='stroke-[1.5] w-20 h-20' />
                  Deploy existing code
                </span>
              </label>
            </li>
            <li className='pb-15 mb-15 last:pb-0 last:mb-0 border-b border-border last:border-none'>
              <label className='cus-checkbox to-do text-text-primary flex items-center gap-10'>
                <input type='checkbox' />
                <span className='checkmark'></span>
                <span className='to-do-text flex items-center gap-5'>
                  <IconCalendarBolt className='stroke-[1.5] w-20 h-20' />
                  Report Panel Usag
                </span>
              </label>
            </li>
          </ul>
        </div>
      </div>
      <div className='grid lg:grid-cols-12 grid-cols-1 gap-30 mb-30'>
        <div className='lg:col-span-8 bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
          <div className='text-[16px]/[19.2px] font-medium mb-10'>
            Project List
          </div>
          <div className='react-data-table'>
            <ReactDataTable
              columns={columnsFilter}
              data={filteredItems}
              pagination
              paginationResetDefaultPage={resetPaginationToggle}
              subHeader
              subHeaderComponent={subHeaderComponentMemo}
            />
          </div>
        </div>
        <div className='lg:col-span-4 flex flex-col gap-30'>
          <div className='md:p-20 p-15 bg-bg-dark rounded-lg shadow-light'>
            <p className='text-[16px]/[19.2px] font-medium'>
              Income Analysis
            </p>
            <small className='text-text-secondary'>
              8% High then last month
            </small>
            <div className='my-10'>
              <ReactApexChart options={chartData5.options} series={chartData5.series} type="pie" className="max-w-[200px] mx-auto" />
            </div>
          </div>
          <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
            <p className='text-[16px]/[19.2px] font-medium mb-20'>
              Sales Income
            </p>
            <p className='text-[16px]/[19.2px] font-medium mb-20'>
              Overall <span className='text-primary'>7,000</span>
            </p>
            <ReactApexChart options={chartData6.options} series={chartData6.series} type="area" height={80} width="100%" />
          </div>
        </div>
      </div>
      <div>
        <p className='text-[20px]/[24px] font-medium mb-5'>
          Lucid Team
        </p>
        <p className='text-text-secondary mb-15'>
          It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.
        </p>
        <div className='grid xxl:grid-cols-4 md:grid-cols-2 md:gap-30 gap-15'>
          <div className='bg-bg-dark shadow-light rounded-lg md:p-20 p-15 flex flex-col items-center justify-center text-center'>
            <p className='font-medium text-[16px]/[19.2px] mb-30'>
              Web Development Team
            </p>
            <div className='border border-border rounded-full p-1 mb-2'>
              <img src={avatar11} alt='user' width="90" height="90" className='w-[90px] h-[90px] rounded-full' />
            </div>
            <p className='font-medium text-[16px]/[20px] text-primary'>
              Susie Willis
            </p>
            <p className='text-text-secondary mb-20'>
              Team Lead
            </p>
            <div className='flex items-center gap-5 mb-20'>
              <span className='inline-block rounded-lg text-white bg-warning py-[3px] px-2 text-[10.5px]/[12px]'>
                ReactJS
              </span>
              <span className='inline-block rounded-lg text-white bg-warning py-[3px] px-2 text-[10.5px]/[12px]'>
                Angular
              </span>
              <span className='inline-block rounded-lg text-white bg-warning py-[3px] px-2 text-[10.5px]/[12px]'>
                VueJS
              </span>
            </div>
            <div className="flex items-center gap-5 mb-20">
              <p className='text-text-secondary font-medium'>Employees : </p>
              <ul className="flex items-center">
                <li className='hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar6} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
                <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar7} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
                <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar8} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
                <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar9} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
                <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar10} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
              </ul>
            </div>
            <p className='text-[16px]/[24px] text-text-secondary'>
              1 Lead, 3 Employees
            </p>
          </div>
          <div className='bg-bg-dark shadow-light rounded-lg md:p-20 p-15 flex flex-col items-center justify-center text-center'>
            <p className='font-medium text-[16px]/[19.2px] mb-30'>
              Marketing Team
            </p>
            <div className='border border-border rounded-full p-1 mb-2'>
              <img src={avatar12} alt='user' width="90" height="90" className='w-[90px] h-[90px] rounded-full' />
            </div>
            <p className='font-medium text-[16px]/[20px] text-primary'>
              Debra Stewart
            </p>
            <p className='text-text-secondary mb-20'>
              Team Lead
            </p>
            <div className='flex items-center gap-5 mb-20'>
              <span className='inline-block rounded-lg text-white bg-warning py-[3px] px-2 text-[10.5px]/[12px]'>
                Social
              </span>
              <span className='inline-block rounded-lg text-white bg-warning py-[3px] px-2 text-[10.5px]/[12px]'>
                HTML/CSS
              </span>
              <span className='inline-block rounded-lg text-white bg-warning py-[3px] px-2 text-[10.5px]/[12px]'>
                Twitter
              </span>
            </div>
            <div className="flex items-center gap-5 mb-20">
              <p className='text-text-secondary font-medium'>Employees : </p>
              <ul className="flex items-center">
                <li className='hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar6} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
                <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar7} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
                <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar8} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
                <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar9} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
              </ul>
            </div>
            <p className='text-[16px]/[24px] text-text-secondary'>
              1 Lead, 3 Employees
            </p>
          </div>
          <div className='bg-bg-dark shadow-light rounded-lg md:p-20 p-15 flex flex-col items-center justify-center text-center'>
            <p className='font-medium text-[16px]/[19.2px] mb-30'>
              Sales Team
            </p>
            <div className='border border-border rounded-full p-1 mb-2'>
              <img src={avatar13} alt='user' width="90" height="90" className='w-[90px] h-[90px] rounded-full' />
            </div>
            <p className='font-medium text-[16px]/[20px] text-primary'>
              Erin Gonzales
            </p>
            <p className='text-text-secondary mb-20'>
              Team Lead
            </p>
            <div className='flex items-center gap-5 mb-20'>
              <span className='inline-block rounded-lg text-white bg-warning py-[3px] px-2 text-[10.5px]/[12px]'>
                Photoshop
              </span>
              <span className='inline-block rounded-lg text-white bg-warning py-[3px] px-2 text-[10.5px]/[12px]'>
                HTML/CSS
              </span>
              <span className='inline-block rounded-lg text-white bg-warning py-[3px] px-2 text-[10.5px]/[12px]'>
                Javascript
              </span>
            </div>
            <div className="flex items-center gap-5 mb-20">
              <p className='text-text-secondary font-medium'>Employees : </p>
              <ul className="flex items-center">
                <li className='hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar6} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
                <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar7} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
                <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar8} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
              </ul>
            </div>
            <p className='text-[16px]/[24px] text-text-secondary'>
              1 Lead, 3 Employees
            </p>
          </div>
          <div className='bg-bg-dark shadow-light rounded-lg md:p-20 p-15 flex flex-col items-center justify-center text-center'>
            <p className='font-medium text-[16px]/[19.2px] mb-30'>
              Web Designing Team
            </p>
            <div className='border border-border rounded-full p-1 mb-2'>
              <img src={userProfile} alt='user' width="90" height="90" className='w-[90px] h-[90px] rounded-full' />
            </div>
            <p className='font-medium text-[16px]/[20px] text-primary'>
              Marshall Nichols
            </p>
            <p className='text-text-secondary mb-20'>
              Team Lead
            </p>
            <div className='flex items-center gap-5 mb-20'>
              <span className='inline-block rounded-lg text-white bg-warning py-[3px] px-2 text-[10.5px]/[12px]'>
                Photoshop
              </span>
              <span className='inline-block rounded-lg text-white bg-warning py-[3px] px-2 text-[10.5px]/[12px]'>
                HTML/CSS
              </span>
              <span className='inline-block rounded-lg text-white bg-warning py-[3px] px-2 text-[10.5px]/[12px]'>
                Javascript
              </span>
            </div>
            <div className="flex items-center gap-5 mb-20">
              <p className='text-text-secondary font-medium'>Employees : </p>
              <ul className="flex items-center">
                <li className='hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar6} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
                <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar7} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
                <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar8} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
                <li className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar9} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
              </ul>
            </div>
            <p className='text-[16px]/[24px] text-text-secondary'>
              1 Lead, 3 Employees
            </p>
          </div>
        </div>
      </div>
    </>
  )
}
